import React from 'react'
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export default obj => {
  if (
    !obj 
    || !obj.json
  ) {
    return null
  }

  let modifiedJSON = { ...obj.json }
  const lastItem = obj.json.content[obj.json.content.length - 1]

  if (
    lastItem.nodeType === 'paragraph'
    && !lastItem.content[0].value
  ) {
    modifiedJSON.content.pop()
  }

  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: node => {
        const { fields } = node.data.target
        return <img src={fields.file['en-US'].url} />
      },
    },
  };
  

  return documentToReactComponents(modifiedJSON, options)
}